import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=6b7c3f8c&scoped=true&"
import script from "./ProductInventory.vue?vue&type=script&lang=js&"
export * from "./ProductInventory.vue?vue&type=script&lang=js&"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&id=6b7c3f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c3f8c",
  null
  
)

export default component.exports